// extracted by mini-css-extract-plugin
export default {"container":"sj-z","bubbleNav":"tj-z","graphic":"uj-z","contact":"vj-z"};